import dynamic from 'next/dynamic'
import { memo, FunctionComponent } from 'react'
import { CookWidget } from '@widgets/types'
import useRiAdTagManagerInit from '@hooks/useRiAdTagManagerInit'

const LoadAdsArticle = dynamic(() => import('./LoadAdsArticle'), {
  ssr: false,
})

const LoadsAdsArticleWrapper: FunctionComponent = () => {
  const tagManagerInitCode = useRiAdTagManagerInit()

  return tagManagerInitCode ? <LoadAdsArticle key={tagManagerInitCode} /> : null
}

const MemoizedLoadLoadsAdsArticleWrapper = memo(LoadsAdsArticleWrapper)

MemoizedLoadLoadsAdsArticleWrapper.displayName =
  'MemoizedLoadLoadsAdsArticleWrapper'

const widget: CookWidget = {
  kind: ['load-ads-article'],
  component: MemoizedLoadLoadsAdsArticleWrapper,
}

export default widget
